export default __webpack_public_path__ + "static/media/video5.6d96cd76.webp";